import React from "react";
import PropTypes from "prop-types";
const AddTagIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 19 17"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-4-5h24v24H-4z" />
      <path d="M0-1h16v16H0z" />
      <path
        fill={color || "var(--color-easil-gray-x-dark)"}
        d="M16 12h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2h-2a1 1 0 0 1 0-2h2v-2a1 1 0 0 1 2 0v2z"
      />
      <path d="M0-1h16v16H0z" />
      <path
        fill={color || "var(--color-easil-gray-x-dark)"}
        fillRule="nonzero"
        d="M8 12a1 1 0 0 1 0 2H6.258a2 2 0 0 1-1.473-.647L.815 9.029a3 3 0 0 1 0-4.058L4.785.647A2 2 0 0 1 6.258 0H13a3 3 0 0 1 3 3v3a1 1 0 0 1-2 0V3a1 1 0 0 0-1-1H6.258l-3.97 4.324a1 1 0 0 0 0 1.352L6.259 12H8z"
      />
    </g>
  </svg>
);
AddTagIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default AddTagIcon;
